import styled, { keyframes } from "styled-components";
import { fadeInLeft } from "react-animations";

// Keyframes
const fadeInRightAnimation = keyframes`${fadeInLeft}`;

// Styles
export const InfoMainDiv = styled.div`
  width: 100%;
`;
export const InfoButton = styled.button`
  margin: 0 auto 10px;
  padding: 2px 15px;
  width: 85%;
  border: none;
  display: none;
  align-items: center;
  justify-content: space-between;
  background-color: #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
  }
`;
export const IndicatorDiv = styled.div`
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  margin: 0 auto 15px;
  @media (max-width: 910px) {
    padding: 0 0 10px;
    width: 85%;
    border-bottom: 2px solid #ccc;
    display: ${({ display }) => display && display};
    animation: 1s ${fadeInRightAnimation};
  }
`;

export const InfoText = styled.p`
  font-size: 14px;
  color: #000;
`;
export const InfoArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
